import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { Box, FlexBox } from '../box';
import { Typography } from '../typography';
export const LanguagePickerMenuItem = observer((props) => {
    const { option } = props;
    const dotColor = option.valid
        ? 'success.main'
        : 'components.stepper.swipe';
    return (_jsxs(FlexBox, { width: 220, height: 40, gap: 1, vAlign: "center", justifyContent: "space-between", children: [_jsx(Typography, { variant: "body2", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: 180, children: option.label }), _jsx(Color, { color: dotColor })] }));
});
const Color = (props) => {
    return (_jsx(Box, { bgcolor: props.color, width: 10, height: 10, borderRadius: "50%" }));
};
